export default "__VITE_ASSET__w97T$DSa__"